import React from 'react';
import { RestaurantUsageStats } from './RestaurantUsageStats';
import { Card, CardContent } from '@/components/ui/card';
import { Info } from 'lucide-react';
import { PromoPerformanceSummaryCard } from '@/components/sms/reports/PromoPerformanceSummaryCard';
import { useAuth } from '@/context/auth/useAuth';

export const SmsReports: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      {/* Info card */}
      <Card className="bg-muted/50">
        <CardContent className="p-4">
          <div className="flex items-start gap-2">
            <Info className="h-5 w-5 text-blue-500 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="font-medium">SMS Usage & Performance Reports</h3>
              <p className="text-sm text-muted-foreground">
                View detailed SMS usage statistics and promo code performance for your organisation. 
                Filter by restaurant, time period, and export data for reporting.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      {/* Promo Code Performance Summary */}
      <PromoPerformanceSummaryCard 
        organisationId={user?.organisationId}
        restaurantIds={user?.restaurants?.map(r => r.id)}
      />
      
      {/* Usage statistics component */}
      <RestaurantUsageStats />
    </div>
  );
};

export default SmsReports;